
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Banner extends Vue {
  @Prop()
  public freeTrialDays!: number;
  @Prop()
  public branding!: string;
  @Prop({ default: false })
  public isSplit!: boolean;
}
